/* Ellips shop: All products page (store rebuild 2026-09-24).
   1. Card ADD TO CART: the card form posts to /cart/add without JavaScript. With the cart drawer script
      (window.ElCart, assets/el-cart.js) it goes through ElCart.add instead, which adds the line (Starter jars keep
      their selling plan), syncs the Ritual Kit, updates the counts and opens the drawer.
   2. Sort: the phone drawer has no sort of its own; its hidden sort_by field follows the bar's select so ticking a
      filter keeps the chosen order. Filtering and sorting themselves are Dawn's facets.js. */
(function () {
  'use strict';

  function setBusy(button, busy) {
    if (!button) return;
    button.classList.toggle('is-loading', busy);
    if (busy) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || typeof form.matches !== 'function' || !form.matches('form[data-el-card-form]')) return;

    var cart = window.ElCart;
    if (!cart || typeof cart.add !== 'function') return; /* no drawer script: let the browser post the form */

    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button && (button.disabled || button.getAttribute('aria-busy') === 'true')) return;

    var data = new FormData(form);
    var item = { id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1 };
    var plan = data.get('selling_plan');
    if (plan) item.selling_plan = Number(plan);

    setBusy(button, true);
    var done = function () { setBusy(button, false); };
    var pending;
    try {
      pending = cart.add([item]);
    } catch (error) {
      /* The drawer script failed before sending anything: fall back to the plain form post. */
      done();
      if (window.console) console.error(error);
      HTMLFormElement.prototype.submit.call(form);
      return;
    }
    /* On a rejected add ElCart shows Shopify's message in the drawer; posting again could add the jar twice. */
    Promise.resolve(pending).then(done, done);
  });

  function syncSortMirror(value) {
    var sort = value;
    if (sort == null) {
      var select = document.getElementById('SortBy');
      sort = select ? select.value : new URLSearchParams(window.location.search).get('sort_by');
    }
    if (!sort) return;
    document.querySelectorAll('[data-el-sort-mirror]').forEach(function (input) {
      input.value = sort;
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.id === 'SortBy') syncSortMirror(target.value);
  });

  function watchGrid() {
    syncSortMirror();
    var grid = document.getElementById('ProductGridContainer');
    if (!grid || typeof MutationObserver !== 'function') return;
    /* facets.js swaps the grid after the filters and the sort select: re-read the sort then (also after Back). */
    new MutationObserver(function () { syncSortMirror(); }).observe(grid, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchGrid);
  } else {
    watchGrid();
  }
  document.addEventListener('shopify:section:load', watchGrid);
})();
